import { render, staticRenderFns } from "./LabSeparatingMixture.vue?vue&type=template&id=9d53da36&"
import script from "./LabSeparatingMixture.vue?vue&type=script&lang=ts&"
export * from "./LabSeparatingMixture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports